'use client';
import { KibApplicationManager } from '@chewy/kib-application-react';
import './accessibility.css';
import HelpCenterContainer from '@/components/helpCenter/helpCenterContainer';
import { AccessibilityProvider } from './AccessibilityProvider';
import React, { useEffect } from 'react';
import { useParams } from 'next/navigation';
import { usePage } from '@chewy/use-analytics';
import useAuthentication from '@/hooks/useAuthentication';

export default function HelpCenterClient() {
  const page = usePage();
  const params = useParams<{ id?: string[] | string }>();
  // Catch-all route params arrive as a string[]; join with '/' so nested
  // topic/section/article ids match the slash-delimited ids in findTopicsByID.
  const rawId = params.id;
  const id = Array.isArray(rawId) ? rawId.join('/') : (rawId ?? '');

  // Doing this to make sure the auth tokens are set
  const { headers, cookies } = useAuthentication();

  useEffect(() => {
    page({
      id: 'help-center-page-viewed-id',
      parentId: 'help-center-id',
      level: 'help-center',
      type: 'page',
      position: 1,
      event_name: 'Page Viewed',
      eventAction: 'impression',
      eventCategory: 'help-center-landing-page',
      eventLabel: 'help-center-landing-page-view',
      name: 'Help Center Page Viewed',
      pageName: `Help Center Page Viewed - ${id}`,
      title: `Chewy Online Help Center`
    });
  }, [page, id]);

  return (
    <KibApplicationManager>
      <AccessibilityProvider>
        <HelpCenterContainer id={id} />
      </AccessibilityProvider>
    </KibApplicationManager>
  );
}
